import React from "react";
import SafetyImg from "../../assets/img/home-safety.png";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";

const Safety = () => {
    return <div className={clsx(
        "flex flex-col items-center gap-[24px] py-[40px] border-b border-[#161616] relative px-[16px]",
        "md:py-[120px]"
    )}>
        <AnimatedContent className="relative z-[3]">
            <div className={clsx(
                "text-[32px] font-semibold leading-[1.2] text-center tracking-[-1.28px]",
                "md:text-[46px] md:tracking-[-1.84px]"
            )}>
                Built for safety. Designed for performance.
            </div>
        </AnimatedContent>
        <AnimatedContent className="relative z-[3]">
            <div className={clsx(
                "text-[14px] text-white/70 text-center leading-[1.5] tracking-[-0.64px]",
                "md:text-white/50 md:text-start"
            )}>
                TaoFlow protects capital with real-time risk management and on-chain enforcement — so both depositors and traders can operate with confidence.
            </div>
        </AnimatedContent>
        <img src={SafetyImg} alt="Safety" className={clsx(
            "absolute bottom-0 left-[50%] translate-x-[-50%] w-full h-[120%] object-contain max-w-[424px]",
            "md:h-[130%]"
        )} />
    </div>;
};

export default Safety;
